module.exports = __webpack_public_path__ + "img/smartEnergy-sm.79796990.jpg";